import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
  } = columns(data);

  return [
    {
      Header: 'History',
      columns: [
        new TextColumn('Outbound Operator', 'operatorFrom'),
        new TextColumn('Outbound IMPC', 'impcFrom'),
        new TextColumn('Inbound Operator', 'operatorTo'),
        new TextColumn('Inbound IMPC', 'impcTo'),
        new NonZeroNumberColumn('Quantity', 'quantity'),
        new DateTimeColumn('Planned Departure date & time', 'departureDate'),
        new DateTimeColumn('Planned Arrival date & time', 'arrivalDate'),
        new TextColumn('User', 'lastUpdateUser'),
        new TextColumn('Comments', 'comments'),
        new TextColumn('Status', 'status'),
        new DateTimeColumn('Last Updated', 'lastUpdateDate'),
      ],
    },
  ];
};
